import React from 'react'
import styled from 'styled-components'
import { sauBanks, uaeBanks } from '../data/banks'
import chevron from '../images/chevron-forward.png'

const Wrapper = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
`
const Row = styled.p`
    position: relative;
    margin: 0;
    padding: 18px 0;
    border-bottom: 0.5px solid #E4E7E7;

    &:after {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        right: 0px;
        background: url(${chevron});
        background-size: contain;
    }
`

const BankList = ({ updateCurrentState, setSelectedBank, country }) => {
    const selectBank = (bank, locale) => {
        setSelectedBank(bank)
        if (locale === "ARE"){
        updateCurrentState("PERMISSION")}
            else {
                updateCurrentState("PREDIRECT")
            }
    }

    return (
        <Wrapper>
            {country === "ARE" && uaeBanks.map((bank) => <Row key={bank} onClick={() => selectBank(bank, "ARE")}>{bank}</Row>)}
            {country === "SAU" && sauBanks.map((bank) => <Row key={bank} onClick={() => selectBank(bank, "SAU")}>{bank}</Row>)}
        </Wrapper>
    )
}

export default BankList